import { EquipAffix } from "../equipmentType";
import { entryPool, entryDeBuffPool } from "./entries";
// 前缀池
const prePool = {
  天选: {
    affName: "天选",
    affProps: [entryPool.STRV2]
  },
  精准: {
    affName: "精准",
    affProps: [entryPool.CRRV2]
  },
  强袭: {
    affName: "强袭",
    affProps: [entryPool.ATKV2]
  },
  鬼影: {
    affName: "鬼影",
    affProps: [entryPool.DEXV2]
  },
  强壮: {
    affName: "强壮",
    affProps: [entryPool.VITV2]
  },
  鹰眼: {
    affName: "鹰眼",
    affProps: [entryPool.CRDV2, entryPool.CRRV2, entryDeBuffPool.DASV]
  },
  敏锐: {
    affName: "敏锐",
    affProps: [entryPool.CRDV2]
  },
  神影: {
    affName: "神影",
    affProps: [entryPool.ATKV, entryPool.ASV]
  },
  崩裂: {
    affName: "崩裂",
    affProps: [entryPool.ATKV, entryPool.STRV]
  },
  不动: {
    affName: "不动",
    affProps: [entryPool.DEFV2, entryPool.HPV2]
  },
  天雕: {
    affName: "天雕",
    affProps: [entryPool.ASV, entryPool.CRRV, entryPool.CRDV]
  },
  鬼斧: {
    affName: "鬼斧",
    affProps: [entryPool.DEXV, entryPool.HPV2]
  }
};
const prePoolList: EquipAffix[] = Object.values(prePool);

export { prePool, prePoolList };
